import ClientProfileViewModalModule from './client-profile-view-modal.module'

export default ClientProfileViewModalModule
